import {
  AfterContentInit,
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Registration} from '../../models/registration';
import {
  ExtendedSearchReqResponse, PatternSearchResponse,
  SearchReqResponse,
  SearchService,
} from 'src/app/services/search-service';
import {RegistrationService} from 'src/app/services/registration-service';
import {SynonymResult} from 'src/app/models/synonymResult';
import {BYOTermResponse} from 'src/app/models/byoTermResponse';
import {UserService} from 'src/app/services/user-service';
import {LoggerService} from 'src/app/services/logger-service';
import {AltSearchOption} from 'src/app/models/altSearchOption';
import {QuickSignupService} from 'src/app/services/quick-signup-service';
import {SessionService} from 'src/app/services/session-service';
import {
  TrackingService,
  TRACKING_SEARCH_TYPE,
} from 'src/app/services/tracking-service';
import {FeatureType} from 'src/app/components/featured-plates/featured-plates.component';
import {PlatexUserAlert} from 'src/app/models/platexUserAlert';
import {PAGE_PLACEMENTS, PagePlacement} from 'src/app/components/page-placement/page-placement.component';
import {
  SidebarFilter,
  SidebarFilterConfig,
  SidebarFilterGroup
} from 'src/app/components/side-bar-filters/side-bar-filters.component';
import {DropdownConfig, DropdownOption} from 'src/app/components/custom-dropdown/custom-dropdown.component';
import {environment} from 'src/environments/environment';
import {StickyConfig, StickyLink, StickyLinkGroup} from 'src/app/components/sticky-tabs/sticky-tabs.component';
import {ViewportScroller} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';
import {FeedbackDialogModalComponent} from 'src/app/components/feedback-dialog-modal/feedback-dialog-modal.component';

export interface SearchFilters {
  sortBy: string,
  up_to_350: boolean;
  from_350_to_750: boolean;
  over_750: boolean;
  new_issue: boolean;
  new_release: boolean;
  resale: boolean;
  auction: boolean;
  private_listing: boolean;
  current: boolean;
  prefix: boolean;
  suffix: boolean;
  dateless: boolean;
}

@Component({
  selector: 'pla-search-results-page',
  templateUrl: './search-results-page.component.html',
  styleUrls: ['./search-results-page.component.scss'],
})
export class SearchResultsPageComponent implements OnInit, AfterViewInit {
  public sortTrigger: EventEmitter<void> = new EventEmitter<void>();
  public searchTrigger: EventEmitter<void> = new EventEmitter<void>();
  public mobileFilterToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  public newlyListedResults: SearchReqResponse;
  public npFeatured = new FeatureType(
    'Recently Added',
    'recently-added'
  );

  public currentFilters: any = {};
  public filterChange: EventEmitter<SearchFilters> = new EventEmitter<SearchFilters>();
  public sortDropdownConfig: DropdownConfig = new DropdownConfig('Sort By', 'swap_vert', [
    new DropdownOption('most-relevant', 'Most Relevant'),
    new DropdownOption('price-ascending', 'Price Low to High'),
    new DropdownOption('price-descending', 'Price High to Low')
  ]);
  public filterUpdate: EventEmitter<SidebarFilterConfig<any>> =
    new EventEmitter<SidebarFilterConfig<any>>();
  public searchFilters: SidebarFilterConfig<SearchFilters> =
    new SidebarFilterConfig<SearchFilters>(
      [
        // new SidebarFilterGroup('Vehicle Suitability', [
        //   new SidebarFilter('select', '', 'vehicleSuitability', {
        //     selectConfig: new DropdownConfig('Age Check', 'filter_alt', [
        //       new DropdownOption('age_check', 'Age Check')
        //     ])
        //   })
        // ]),
        new SidebarFilterGroup('Sort By', [
          new SidebarFilter('sort', 'Sort By', 'sortBy', {
            selectConfig: this.sortDropdownConfig
          })
        ], {visible: true, customClass: 'd-block d-lg-none'}),
        new SidebarFilterGroup('Price', [
          new SidebarFilter('checkbox', 'Up To £350', 'up_to_350'),
          new SidebarFilter('checkbox', '£350 to £750', 'from_350_to_750'),
          new SidebarFilter('checkbox', 'Over £750', 'over_750'),
        ]),
        new SidebarFilterGroup('Sale Type', [
          new SidebarFilter('checkbox', 'New Issue', 'new_issue'),
          new SidebarFilter('checkbox', 'Resale', 'resale'),
          // new SidebarFilter('checkbox', 'Auction', 'auction'),
          // new SidebarFilter('checkbox', 'Private Listing', 'private_listing'),
        ]),
        new SidebarFilterGroup('Plate Type', [
          new SidebarFilter('checkbox', 'Current', 'current'),
          new SidebarFilter('checkbox', 'Prefix', 'prefix'),
          new SidebarFilter('checkbox', 'Suffix', 'suffix'),
          new SidebarFilter('checkbox', 'Dateless', 'dateless'),
        ]),
      ],
      this.filterChange
    );
  public ownSimilarPlacement: PagePlacement = PAGE_PLACEMENTS.OWN_SIMILAR_FREE_3_MONTHS();
  public howDidWeDo: PagePlacement = PAGE_PLACEMENTS.HOW_DID_WE_DO();

  public pending_merge: boolean = false;
  public combined_main_results: SearchReqResponse;
  public combined_results_change: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();

  private searchStartTime: number;
  public superSearchAttempt = 0;
  public results: SearchReqResponse;
  public v3_results_map: { thirdParty: boolean, result: SearchReqResponse }[] = [];
  public v3_results: SearchReqResponse;
  public perfectResults: SearchReqResponse;
  public wildcardResults: SearchReqResponse;
  public synonymResults: SynonymResult[];
  public patternWildcard: string;
  public patternResults: SearchReqResponse[];
  public perfectSearching: boolean;
  public superSearching: boolean;
  public v3Searching: boolean;
  public superSearchComplete: EventEmitter<void> = new EventEmitter<void>();
  public wildcardSearching: boolean;
  public byoTerm: BYOTermResponse;
  public alternativeOptions: AltSearchOption[];
  private allChips: StickyLink[] = [
    new StickyLink('Close Matches', 'close-matches', true),
    new StickyLink('Similar', 'similar', false),
    new StickyLink('Current Lists', 'current-lists', false),
    new StickyLink('Prefix Lists', 'prefix-lists', false),
    // new StickyLink('Q&As', 'faq', false),
  ]
  public stickyLinkConfig: StickyConfig = new StickyConfig(
    [new StickyLinkGroup(this.allChips)],
    new EventEmitter<void>()
  );

  public searchCriteria: string;
  public routeFrom: string;
  public newlyListedResultChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();
  public resultChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();
  public v3_resultChange: EventEmitter<SearchReqResponse> = new EventEmitter<SearchReqResponse>();
  public perfectResultChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();

  public currentResults: SearchReqResponse[];
  public prefixResults: SearchReqResponse[];

  public wildcardResultChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();

  public bannerRegistration: string = 'S34 RCH';
  public bannerUpdate: EventEmitter<string> = new EventEmitter<string>();
  public fetchedAlerts: boolean = false;
  public alertActionLoading: boolean = false;
  public shownPopup: boolean = false;

  constructor(
    private searchService: SearchService,
    private userService: UserService,
    private registrationService: RegistrationService,
    private route: ActivatedRoute,
    private loggerService: LoggerService,
    private router: Router,
    public sessionService: SessionService,
    private quickSignupService: QuickSignupService,
    private trackingService: TrackingService,
    private viewportScroller: ViewportScroller,
    private dialog: MatDialog,
  ) {
    this.searchCriteria = this.route.snapshot.params.searchCriteria;
    this.routeFrom = this.route.snapshot.queryParams['routeFrom'];
    this.trackingService.TrackSearch(
      TRACKING_SEARCH_TYPE.MAIN,
      this.searchCriteria
    );
    this.filterChange.subscribe((_: SearchFilters) => this.currentFilters = _);
  }

  ngOnInit(): void {
    this.userService.getPlatexUserAlerts(() => {
      this.fetchedAlerts = true;
    });

    if (this.superSearching || this.perfectSearching || this.wildcardSearching) {
      return;
    }

    this.search();
    // this.searchAltTerms();
  }

  ngAfterViewInit(): void {
    window.scrollTo(0, 1);
    setTimeout(() => {
      window.scrollTo(0, 1);
    }, 100);
  }

  public SortChange(e: DropdownOption, key: string): void {
    this.currentFilters[key] = e.value;
    this.filterChange.emit(this.currentFilters);
  }

  public generateSynonymHeaderText(synonymResult: SynonymResult): string {
    return `Similar search results to ${this.searchCriteria.toUpperCase()}`;
    return `Alternative search results for ${this.searchCriteria.toUpperCase()} - "${synonymResult.synonym.toUpperCase()}"`;
  }

  public routeToNewSearch(term: AltSearchOption): void {
    this.router.navigate([`/search-results/${term.term}`], {
      queryParams: {routeFrom: this.searchCriteria.toUpperCase()},
    });
  }

  // Single page-level feedback entry point. Replaces the per-row "Seen an error?"
  // links removed in this PR — same modal, same /feedback endpoint, same Jira
  // pipeline; only the surfacing changes.
  public reportPageIssue(): void {
    this.dialog.open(FeedbackDialogModalComponent, {
      width: '420px',
      maxWidth: '92vw',
      data: {
        context: {
          source: 'search-results-page',
          term: this.searchCriteria,
        },
      },
    });
  }

  public hasAlert(): boolean {
    return this.userService.hasAlert(this.searchCriteria);
  }

  public addQuickAlert(): void {
    if (this.alertActionLoading) return;
    if (!this.searchCriteria || this.searchCriteria == '') return;
    this.alertActionLoading = true;
    var alert = new PlatexUserAlert();
    alert.term = this.searchCriteria;
    alert.registrationStyle = 'all_styles';
    this.userService.addAlert(alert, (_alerts: PlatexUserAlert[]) => {
      this.alertActionLoading = false;
    }, () => {
      this.alertActionLoading = false;
    });
  }

  public cancelQuickAlert(): void {
    if (this.alertActionLoading) return;
    if (!this.searchCriteria || this.searchCriteria == '') return;
    this.alertActionLoading = true;
    var alert = new PlatexUserAlert();
    alert.term = this.searchCriteria;
    this.userService.removeAlert(alert, (_alerts: PlatexUserAlert[]) => {
      this.alertActionLoading = false;
    }, () => {
      this.alertActionLoading = false;
    });
  }

  public search() {
    this.searchStartTime = new Date().getTime();
    this.perfectSearching = true;
    this.superSearching = true;
    this.wildcardSearching = true;
    this.userService.getUserData(() => {
      setTimeout(() => {
        this.viewportScroller.scrollToAnchor('recent-searches');
      }, 500);
      this.searchRaw(() => {
      });
      this.searchV3(true);
      this.searchV3(false);
      this.searchSynonym();
      this.searchPattern();
      this.searchPerfect(() => {
        this.searchComplete();
        // this.getBYO();
      });
      this.searchExtended();
    });
  }

  private searchComplete(): void {
    if (this.perfectResults == undefined || this.results == undefined) return;
    if (this.searchCriteria) {
      var resultCount = this.perfectResults.registrations.length + this.results.registrations.length
      this.userService.addSearchToHistory(this.searchCriteria, `${resultCount} Results`);
    }

    this.filterUpdate.emit(this.searchFilters); // updates order
  }

  // private searchAltTerms(): void {
  //   return; // TODO: RE-ADD
  //   this.searchService.getAltSearchTerms(
  //     this.searchCriteria.toUpperCase(),
  //     (_: AltSearchOption[]) => {
  //       if (
  //         this.routeFrom &&
  //         _.filter((__) => __.term == this.routeFrom).length == 0
  //       )
  //         _.push(
  //           new AltSearchOption(this.routeFrom, this.routeFrom, 'original')
  //         );
  //       if (_ != null) this.alternativeOptions = _.reverse();
  //     }
  //   );
  // }

  private searchExtended(): void {

    this.stickyLinkConfig.groups[0].links.map(c => {
      if (c.anchor === 'current-lists') c.hidden = true;
      if (c.anchor === 'prefix-lists') c.hidden = true;
    });

    this.searchService.extendedSearch(this.searchCriteria, 'current', (c_req: ExtendedSearchReqResponse[]) => {
      var hasResults = false;
      this.currentResults = c_req.map(x => {
        if (x.results.length > 0) hasResults = true;
        return {id: x.version, registrations: this.registrationService.formatRegistrations(x.results)};
      });
      this.stickyLinkConfig.groups[0].links.map(c => {
        if (c.anchor === 'current-lists') c.hidden = !hasResults;
      })

      this.searchService.extendedSearch(this.searchCriteria, 'prefix', (p_req: ExtendedSearchReqResponse[]) => {
        var hasResults = false;
        this.prefixResults = p_req.map(x => {
          if (x.results.length > 0) hasResults = true;
          return {id: x.version, registrations: this.registrationService.formatRegistrations(x.results)};
        });
        this.stickyLinkConfig.groups[0].links.map(c => {
          if (c.anchor === 'prefix-lists') c.hidden = !hasResults;
        })
      })
    });
  }

  private searchPerfect(callback: () => void = () => {
  }): void {
    this.searchService.searchPerfect(
      this.searchCriteria,
      (res: Registration[]) => {
        try {
          this.perfectSearching = false;
          if (res != null) {
            var formattedResults =
              this.registrationService.formatRegistrations(res);
            const tempSearchReq = new SearchReqResponse(
              'perfect_id',
              formattedResults
            );
            this.perfectResultChange.emit(tempSearchReq);
            this.perfectResults = tempSearchReq;
          }
          callback();
        } catch (ex: any) {
          this.loggerService.logException(ex);
          callback();
        }
      }
    );
  }

  private searchPattern(): void {
    this.searchService.searchPattern(this.searchCriteria, (res: PatternSearchResponse) => {
      let totalResults = 0;
      if (res == null) this.patternResults = null;
      else {
        const currentLength = res.current ? res.current.length : 0;
        const prefixLength = res.prefix ? res.prefix.length : 0;
        const suffixLength = res.suffix ? res.suffix.length : 0;
        const datelessLength = res.dateless ? res.dateless.length : 0;
        totalResults = currentLength + prefixLength + suffixLength + datelessLength;
      }
      if (totalResults <= 0) {
        this.patternResults = null
      } else {
        this.patternWildcard = res.wildcard || this.searchCriteria;
        this.patternResults = [
          new SearchReqResponse('Current Pattern', this.registrationService.formatRegistrations(res.current)),
          new SearchReqResponse('Prefix Pattern', this.registrationService.formatRegistrations(res.prefix)),
          new SearchReqResponse('Suffix Pattern', this.registrationService.formatRegistrations(res.suffix)),
          new SearchReqResponse('Dateless Pattern', this.registrationService.formatRegistrations(res.dateless))
        ]
      }
    });
  }

  private getBYO(callback: () => void = () => {
  }): void {
    this.searchService.getBYOTerm(
      this.searchCriteria,
      (res: BYOTermResponse) => {
        try {
          this.byoTerm = res;
          callback();
        } catch (ex: any) {
          this.loggerService.logException(ex);
          callback();
        }
      }
    );
  }

  private searchSynonym(callback: () => void = () => {
  }): void {

    this.stickyLinkConfig.groups[0].links.map(c => {
      if (c.anchor === 'similar') c.hidden = true;
    });

    this.searchService.searchSynonym(
      this.searchCriteria,
      (res: SynonymResult[]) => {
        try {
          if (res != null) {
            res.map((_res) => {
              _res.resp.id = 'synonym_id';
              _res.resp.registrations =
                this.registrationService.formatRegistrations(
                  _res.resp.registrations
                );
            });
            if (res.length == 0) return;

            const allResults = res.flatMap((r) => r.resp.registrations);
            allResults.sort((a, b) => b.percentage - a.percentage);
            const x = new SynonymResult();
            x.synonym = this.searchCriteria;
            x.resp = new SearchReqResponse(res[0].resp.id, allResults);

            this.synonymResults = [x];
            this.stickyLinkConfig.groups[0].links.map(c => {
              if (c.anchor === 'similar') c.hidden = false;
            });
          }
          callback();
        } catch (ex: any) {
          this.loggerService.logException(ex);
          callback();
        }
      }
    );
  }

  private searchV3(thirdParty: boolean): void {
    this.v3Searching = true;
    this.searchService.searchV3(
      this.searchCriteria,
      (res: SearchReqResponse) => {
        try {
          if (res != null && res.registrations.length > 0) {

            res.registrations = Array.from(
              new Map(res.registrations.map(item => [item.registration, item])).values()
            );

            res.registrations = this.registrationService.formatRegistrations(
              res.registrations
            );
          }
          this.formatNewSearchResults(res, thirdParty);
        } catch (ex: any) {
          this.formatNewSearchResults(null, thirdParty);
          this.loggerService.logException(ex);
        }
      },
      thirdParty
    );
  }

  private formatNewSearchResults(results: SearchReqResponse, thirdParty: boolean): void {
    if (results == null) {
      results = new SearchReqResponse('_____', []);
    }
    const existingIndex = this.v3_results_map.findIndex(r => r.thirdParty === thirdParty);
    if (existingIndex >= 0)
      this.v3_results_map[existingIndex].result = results;
    else
      this.v3_results_map.push({thirdParty, result: results});

    if (this.v3_results_map.length == 2) {
      this.v3_results = new SearchReqResponse(results.id, [...this.v3_results_map[0].result.registrations, ...this.v3_results_map[1].result.registrations]);
      this.v3Searching = false;
      this.v3_resultChange.emit(this.v3_results);
      this.extractNewlyListedFromResults();

      // combine and emit
      if (this.combined_main_results == null) {
        this.searchStartTime = new Date().getTime();
        console.log('COMBINED MAIN RESULTS IS NULL, CREATING NEW V3 COMBINED');
        this.combined_main_results = new SearchReqResponse(`v3_first_combined_${results.id}`, this.v3_results.registrations);
      } else {
        setTimeout(() => {
          this.MergeResults();
        }, 100);
      }

      setTimeout(() => {
        this.combined_results_change.emit(this.combined_main_results);
        this.superSearchComplete.emit();
        this.searchComplete();
      }, 50);
    }
  }

  private searchRaw(callback: () => void = () => {
  }): void {
    this.superSearchAttempt++;
    this.searchService.searchRaw(
      this.searchCriteria,
      (res: SearchReqResponse) => {
        try {
          this.superSearching = false;

          res.registrations = Array.from(
            new Map(res.registrations.map(item => [item.registration, item])).values()
          );

          res.registrations = this.registrationService.formatRegistrations(
            res.registrations
          );

          // FILTER OUT EXISTING REGISTRATIONS
          if (!this.v3Searching && this.v3_results != null) {
            // console.log('SEARCH V3 COMPLETE AND NOW WE FILTER')
            res.registrations = res.registrations.filter(reg => {
              return !this.v3_results.registrations.some(v3Reg => v3Reg.registration === reg.registration);
            });
          }

          this.results = res;

          if (this.combined_main_results == null) {
            console.log('COMBINED MAIN RESULTS IS NULL, CREATING NEW SUPER COMBINED');
            this.combined_main_results = new SearchReqResponse(`super_first_combined_${res.id}`, this.results.registrations);
          } else {
            const searchEndTime = new Date().getTime();
            if (searchEndTime - this.searchStartTime > 5000) {
              console.log('SUPER SEARCH TOOK TOO LONG, NO MERGE', searchEndTime - this.searchStartTime);
              this.pending_merge = true;
            } else {
              console.log('SUPER SEARCH WITHIN RANGE, MERGING RESULTS NOW', searchEndTime - this.searchStartTime);
              setTimeout(() => {
                this.MergeResults();
              }, 100);
            }
          }

          this.combined_results_change.emit(this.combined_main_results);

          setTimeout(() => {
            this.combined_results_change.emit(this.combined_main_results);
            this.superSearchComplete.emit();
            this.extractNewlyListedFromResults();
            this.searchComplete();
            callback();
          }, 50);
        } catch (ex: any) {
          this.loggerService.logException(ex);
          if (this.superSearchAttempt >= 3) { callback(); return; }
          setTimeout(() => {
            console.log('RETRY SUPER SEARCH!!!!');
            this.searchRaw(callback)
          }, 5000);
        }
      }
    );
  }

  public MergeResults(): void {
    const merged = [...this.results.registrations, ...this.v3_results.registrations];
    const unique = Array.from(
      new Map(merged.map(item => [item.registration, item])).values()
    );
    this.combined_main_results.registrations = unique.sort((a, b) => b.percentage - a.percentage).map((reg, i) => {
      reg.index = i + 1;
      return reg;
    });
    this.pending_merge = false;
    setTimeout(() => {
      this.combined_results_change.emit(this.combined_main_results);
      this.searchComplete();
    }, 50);
  }

  private extractNewlyListedFromResults(): void {
    //var auctionPlates: Registration[] = [];
    var newStylePlates: Registration[] = [];
    if (!this.results) return;
    [...this.combined_main_results.registrations].forEach((reg: Registration, i: number) => {
      if (reg.style == 'current' && reg.registration.substring(2, 4) == environment.latestRelease)
        newStylePlates.push(reg);
    });

    const tempSearchReq = new SearchReqResponse('newly_listed', [
      ...newStylePlates.slice(0, 2),
    ]);
    this.newlyListedResults = tempSearchReq;
    this.newlyListedResultChange.emit(this.newlyListedResults);
  }
}
